import policy from './index.cjs';
export const { scrubEvent, scrubSpan, scrubTransaction, isEnabled, startClientTelemetry } = policy;
